import { Education } from "../../data/education";
import { GraduationCap } from "lucide-react"; // 🧠 Needs Lucide (or FontAwesome if preferred)

const EducationItem = ({ edu }: { edu: Education }) => {
  return (
    <div className="relative">
      <div className="page-card flex flex-col items-start gap-4 rounded-2xl p-5 transition hover:-translate-y-1 hover:shadow-[0_20px_44px_rgba(17,35,24,0.14)] sm:flex-row sm:items-center md:p-6">
        {/* School Logo */}
        <div className="h-14 w-14 flex-shrink-0 rounded-xl border border-[color:var(--card-border)] bg-[color:var(--surface-strong)] p-2">
          <img
            src={edu.logo}
            alt={edu.school}
            className="w-full h-full object-contain"
          />
        </div>

        {/* Degree Info */}
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="section-title text-lg font-semibold">
              {edu.degree}
            </h3>
            {edu.graduated && (
              <GraduationCap className="w-5 h-5 text-[#0d7a55]" />
            )}
          </div>
          <p className="body-copy text-sm font-medium">
            {edu.school} — {edu.location}
          </p>
          <p className="meta-copy text-sm">{edu.timeframe}</p>
          <p className="body-copy mt-2 text-sm leading-7">{edu.summary}</p>
        </div>
      </div>
    </div>
  );
};

export default EducationItem;
